const APPSUMO_OAUTH_CODE_KEY = 'opspilot_appsumo_oauth_code';
const APPSUMO_FLOW_KEY = 'opspilot_appsumo_flow';

export const captureAppSumoParamsFromSearch = (search) => {
	const params = new URLSearchParams(search);
	const oauthCode = params.get('code');
	const utmSource = params.get('utm_source');

	if (oauthCode) {
		sessionStorage.setItem(APPSUMO_OAUTH_CODE_KEY, oauthCode);
	}

	if (oauthCode || utmSource === 'appsumo') {
		sessionStorage.setItem(APPSUMO_FLOW_KEY, '1');
	}
};

export const hasAppSumoFlow = () =>
	sessionStorage.getItem(APPSUMO_FLOW_KEY) === '1';

export const getAppSumoOAuthCode = () =>
	sessionStorage.getItem(APPSUMO_OAUTH_CODE_KEY);

export const clearAppSumoSession = () => {
	sessionStorage.removeItem(APPSUMO_OAUTH_CODE_KEY);
	sessionStorage.removeItem(APPSUMO_FLOW_KEY);
};
